import {ArtDerBeteiligungEnum} from '../v2024';

export const ArtDerBeteiligungEnumLabels = {
    PersoenlichHaftenderGesellschafter: '1' as ArtDerBeteiligungEnum,
    Komplementaer: '2' as ArtDerBeteiligungEnum,
    Kommanditist: '3' as ArtDerBeteiligungEnum,
    SonstigerOhneHaftungsbeschraenkung: '4' as ArtDerBeteiligungEnum,
    SonstigerMitHaftungsbeschraenkung: '5' as ArtDerBeteiligungEnum,
    GesellschafterGemeinschafterOhneHaftungsbeschraenkung: '6' as ArtDerBeteiligungEnum,
    GesellschafterGemeinschafterMitHaftungsbeschraenkung: '7' as ArtDerBeteiligungEnum,
    Treuhaender: '8' as ArtDerBeteiligungEnum,
    MittelbarBeteiligterGesellschafter: '10' as ArtDerBeteiligungEnum
};
